var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPodcast = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 24,
  fill: "#4585FF",
  fillOpacity: 0.8
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.1092 23.3303V15.4464C20.1092 14.3477 20.488 13.4111 21.2455 12.6375C22.004 11.8648 22.9214 11.4785 23.9995 11.4785C25.0776 11.4785 25.995 11.8648 26.7525 12.6375C27.511 13.4111 27.8898 14.3477 27.8898 15.4464V23.3303C27.8898 24.4299 27.511 25.3656 26.7525 26.1383C25.995 26.9118 25.0776 27.2982 23.9995 27.2982C22.9214 27.2982 22.004 26.9118 21.2455 26.1383C20.488 25.3656 20.1092 24.4299 20.1092 23.3303ZM33.044 23.3304C33.044 25.5636 32.2938 27.5216 30.7954 29.2045C29.2969 30.8883 27.4695 31.9022 25.3142 32.2452V36.5221H22.6868V32.2452C20.5315 31.9022 18.7041 30.8883 17.2047 29.2045C15.7063 27.5216 14.957 25.5636 14.957 23.3304H17.129C17.129 25.2545 17.8117 26.8601 19.1753 28.1482C20.5398 29.4363 22.1482 30.0808 24.0005 30.0808C25.8528 30.0808 27.4612 29.4363 28.8257 28.1482C30.1893 26.8601 30.8711 25.2545 30.8711 23.3304H33.044Z",
  fill: "white"
})));
export default SvgPodcast;